import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../../../../Apicongfig';
import { useFormContext } from '../../../../../context/CreateMeetingContext';
import { solutionTypeIcons, typeIcons } from '../../../../Utils/MeetingFunctions';

function SolutionTemplateTab() {
    const [selectedId, setSelectedId] = useState(null);
    const [solutions,setSolutions] = useState([])
    const {setFormState,formState,meeting} = useFormContext();

    useEffect(()=>{
        const getSolutionTemplate = async () => {
          try {
            const response  = await axios.get(`${API_BASE_URL}/get-all-solutions`,{headers:{
                Authorization: `Bearer ${sessionStorage.getItem("token")}`
            }});
            if(response?.status === 200){
                console.log("response", response?.data?.data);
                setSolutions(response?.data?.data)
            }
          } catch (error) {
            console.error("Error fetching solution templates:", error);
          }
        }

        getSolutionTemplate();
    },[])

    useEffect(() => {
        // If formState.solution_id exists, set it as selected
        if (meeting?.solution_id) {
            setSelectedId(meeting.solution_id);
        }
    }, [formState?.solution_id,meeting]);

    const handleSelect = (id) => {
        setSelectedId(id);
        setFormState(prev => ({ ...prev, solution_id: id }));
    };
  

    return (
        <div className='mt-2 row justify-content-center'>
            {solutions.map(template => (
                <div key={template.id} className="col-lg-2 col-md-3 col-sm-4 col-6 mb-3">
                    <div
                        className="text-center shadow-sm card"
                        onClick={() => handleSelect(template.id)}

                        style={{
                            borderRadius: '10px',
                            height: '138px',
                            width: '100%',
                            maxWidth: '138px',
                            background: 'none',
                            cursor: 'pointer',
                            border: selectedId === template.id ? '2px solid blue' : '1px solid transparent',
                            transform: 'scale(1.1)',
                            transition: 'transform 0.2s ease-in-out, border 0.2s ease-in-out'
                        }}
                    >
                        <div className="d-flex flex-column justify-content-center align-items-center card-body">
                            {solutionTypeIcons[template?.type]}
                            <div className="mt-2 solutioncards card-title h5 text-center" style={{ wordBreak: 'break-word' }}>
                                {template.title}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default SolutionTemplateTab;

